import { Box, Button, Center, Flex, Link, Text } from "@chakra-ui/react";

type WelcomeScreenProps = {
  startQuizHandler: () => void;
};

const WelcomeScreen = ({ startQuizHandler }: WelcomeScreenProps) => {
  return (
    <Box
      top="50%"
      left="50%"
      position="fixed"
      bg="orange.100"
      w={["80%", "80%", "80%", "40%"]}
      transform="translate(-50%, -50%)"
      h={["60%", "60%", "60%", "40%"]}
      borderRadius={15}
    >
      <Flex
        h="100%"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
      >
        <Text
          fontSize={["2xl", "2xl", "3xl", "4xl"]}
          mt="1.5rem"
          fontFamily="century-gothic"
          fontWeight="400"
        >
          QUIZ
        </Text>
        <Text fontSize="2xl" mr="5rem" ml="5rem" bg="gray.300">
          Welcome at quiz! You can try yourself answering 10 hard questions
          generated by{" "}
          <Link color="teal.500" href="https://opentdb.com/" isExternal>
            Trivia Database
          </Link>
          .
        </Text>
        <Button bg="green.300" w="20%" mb="1.5rem" onClick={startQuizHandler}>
          START
        </Button>
      </Flex>
    </Box>
  );
};

export default WelcomeScreen;
